import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';


function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

 
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[var(--navy-blue-light)] shadow-md' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-2 text-2xl font-bold text-white">
            <img src="/lawfeed-500.png" alt="LawFeed Logo" className="h-16 w-16" />
            <span>LawFeed</span>
          </Link>
          <nav className="hidden md:flex space-x-6 items-center">
           
              <>
                <NavLink to="/planes" isScrolled={isScrolled}>Planes</NavLink>
                <NavLink to="/HomeEcommerce/LawFirmListings" isScrolled={isScrolled}>Buscar Bufetes</NavLink>
                <NavLink to="/registro-cliente" isScrolled={isScrolled}>Registro Cliente</NavLink>
                <NavLink to="/registro-bufete" isScrolled={isScrolled} >Registro Bufete</NavLink>
                <NavLink to="/registro-abogados" isScrolled={isScrolled}>Registro Abogados</NavLink>
                <NavLink to="/login" isScrolled={isScrolled} isButton>Inicio de Sesión</NavLink>
              </>
            
          </nav>
          <button
            className={`md:hidden ${isScrolled ? 'text-blue-600' : 'text-white'}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="md:hidden bg-white shadow-md"
        >
          <nav className="flex flex-col py-4">
            
              <>
                <MobileNavLink to="/planes" onClick={() => setIsMobileMenuOpen(false)}>Planes</MobileNavLink>
                <MobileNavLink to="/HomeEcommerce/LawFirmListings" onClick={() => setIsMobileMenuOpen(false)}>Buscar Bufetes</MobileNavLink>
                <MobileNavLink to="/registro-cliente" onClick={() => setIsMobileMenuOpen(false)}>Registro Cliente</MobileNavLink>
                <MobileNavLink to="/login" onClick={() => setIsMobileMenuOpen(false)}>Inicio de Sesión</MobileNavLink>
                <MobileNavLink to="/registro-abogados" onClick={() => setIsMobileMenuOpen(false)}>Registro Abogados</MobileNavLink>
                <MobileNavLink to="/registro-bufete" onClick={() => setIsMobileMenuOpen(false)}>Registro Bufete</MobileNavLink>
              </>
          </nav>
        </motion.div>
      )}
    </header>
  );  
}

function NavLink({ to, children, isScrolled, isButton }) {
  const baseClasses = `font-medium transition-colors duration-300 ${isScrolled ? 'text-white hover:text-gray-400 ' : 'text-white hover:text-gray-400'}`;
  const buttonClasses = `px-4 py-2 rounded ${isScrolled ? 'bg-[var(--gold)] text-white hover:bg-[var(--gold-dark)]' : 'bg-[var(--gold)] text-white hover:bg-[var(--gold-dark)]'}`;

  return (
    <Link to={to} className={isButton ? `${baseClasses} ${buttonClasses}` : baseClasses}>
      {children}
    </Link>
  );
}

function MobileNavLink({ to, children, onClick }) {
  return (
    <Link to={to} className="block py-2 px-4 text-gray-700 hover:bg-gray-100" onClick={onClick}>
      {children}
    </Link>
  );
}

export default Header;
